import { roundups } from '@/mocks/homeData';

export default function Roundups() {
  return (
    <section id="roundups" className="scroll-mt-24">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="font-label text-xs font-semibold uppercase tracking-[0.3em] text-accent-700"># 专题 · 精选盘点</p>
            <h2 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              编辑整活，<span className="text-primary-600">深扒到底</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">把零散的热点串成一条线，一次讲清楚来龙去脉。</p>
          </div>
        </div>

        {/* 图文并重：大图卡片 */}
        <div className="mt-8 grid gap-5 lg:grid-cols-3">
          {roundups.map((r, i) => (
            <a
              key={r.title}
              href="#briefs"
              className={`group relative flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative w-full overflow-hidden ${i === 0 ? 'h-56 md:h-72' : 'h-52 md:h-64'}`}>
                <img
                  src={r.img}
                  alt={r.title}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/5 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-primary-950">
                  {r.category}
                </span>
                <span className="absolute bottom-4 right-4 flex items-center gap-1 rounded-full bg-background-950/70 px-3 py-1 text-xs font-medium text-background-50 backdrop-blur">
                  <i className="ri-eye-line" /> {r.reads} 已读
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5 md:p-6">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition group-hover:text-primary-700 md:text-xl">
                  {r.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground-600">{r.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-4 text-xs text-foreground-400">
                  <span>{r.date}</span>
                  <span className="flex items-center gap-1 font-medium text-primary-600 transition group-hover:gap-2">
                    读完整盘点 <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}